import React from 'react';
import Navigation from '../components/Navigation.jsx';
import Footer from '../components/Footer.jsx';
const MyApproachPage = () => {
  return <div className="min-h-screen bg-cream-50">
      <Navigation variant="soft-brown" scrolled={true} />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-4 md:px-8 bg-gradient-to-br from-sage-50 via-warm-50 to-cream-50">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-sage-800 mb-6">
            My Approach
          </h1>
          <p className="text-2xl md:text-3xl text-warm-700 font-light italic">Your space. Your pace.</p>
        </div>
      </section>

      {/* Main Content - Single Column Layout */}
      <section className="py-16 px-4 md:px-8 bg-white">
        <div className="max-w-4xl mx-auto space-y-8">
          {/* I Believe Section */}
          <div>
            <h3 className="text-3xl md:text-4xl font-serif font-light text-sage-800 mb-6 text-left">{"I am...."}</h3>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium">{"I am a student. A collaborator. A connector."}</p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              You are the expert on your life situations, challenges, and your body.
              I bring my expertise as a professional.
              Together, we collaborate and attune to the wisdom of your body and nervous system.
            </p>
          </div>

          <div>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">{"In our sessions, everything you bring is welcome."}</p>
            <p className="text-lg text-gray-700 leading-relaxed mb-2 ml-4">
              Your feelings.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-2 ml-4">
              Your doubts.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 ml-4">
              And any anxieties around things changing.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              We'll go at your pace, and I'll meet you right where you are.
            </p>
          </div>

          <div>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium">All of you is good.</p>
            <p className="text-lg text-gray-700 leading-relaxed">{"No parts of us are bad and we have parts that learned to protect us in the best way they knew how."}</p>
          </div>

          <div>
            <p className="text-lg text-gray-700 leading-relaxed">{"When we meet these parts with compassion and curiosity instead of criticism, they begin to relax. And that's where healing happens not by pushing any part away, but by letting every part of you feel seen, understood, valued, appreciated, accepted, and safe."}</p>
          </div>

          <div>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium">
              Our different cultures, identities, and systems significantly shape our experiences.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">As an Asian Indian immigrant who moved to the US at 18, I understand what it's like to navigate cultural expectations, family systems, and the pressure to be the "good daughter", "good wife", "good friend",  "good community member", and "good employee" while finding your own voice.</p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              I care deeply about creating a space where all parts of who you are feel respected and seen.
            </p>
            
            {/* Core Values Word Art */}
            <div className="flex justify-center my-8">
              <img src="https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/user_33tbl7B6e1bXN6KW4wjrevvqrth/cmhd1gtfc0001vb0yeeofdn9z/messages/word-art-3-8ewt3fhy63r.jpeg" alt="Core values word cloud featuring words like Brave, Gutsy, Compassionate, Generous, Kind, Integrity, Sincere, and more" style={{
              transform: 'scale(0.99)'
            }} className="w-full max-w-5xl h-auto rounded-lg shadow-[0_0_#0000,0_0_#0000,0_0_#0000,0_0_#0000,0_0_#0000,0_0_#0000,0_4px_6px_-1px_rgb(0,0,0,0.1),0_2px_4px_-2px_rgb(0,0,0,0.1)] mt-[50px] mb-[50px] ml-0 mr-0 pt-0 pb-0 pl-0 pr-0" />
            </div>
          </div>

          {/* When You Work With Me */}
          <div className="mt-12">
            <h3 className="text-3xl md:text-4xl font-serif font-light text-sage-800 mb-6 text-left">When You Work With Me...</h3>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">{"We will focus on improving your relationship with yourself, by embracing and fiercely loving all parts of you.....   Even the ones that can be hard to love or feel self-limiting, especially the inner critic, people-pleaser, and the task master that can not let you rest right now."}</p>
            
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium">When you work with me, you will:</p>
            
            <ul className="space-y-3 text-lg text-gray-700 leading-relaxed">
              <li className="flex items-start">
                <span className="mr-3 text-sage-600 mt-1">•</span>
                <span>{"Feel heard, seen, deeply valued  and even delighted in"}</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-sage-600 mt-1">•</span>
                <span>Practice offering compassion to the parts of you that are hardest to love</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-sage-600 mt-1">•</span>
                <span>Learn to embrace your limits and say no to what no longer serves you</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-sage-600 mt-1">•</span>
                <span>Grow more at ease with owning your imperfections</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-sage-600 mt-1">•</span>
                <span>Practice nurturing your anger as a source of truth and protection</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-sage-600 mt-1">•</span>
                <span>Begin to prioritize yourself, and invest energy in the relationships and projects that truly matter to you</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-sage-600 mt-1">•</span>
                <span>Expand your capacity to tolerate discomfort and the unknown that life inevitably brings</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-sage-600 mt-1">•</span>
                <span>{"Know, deep in your bones, that you are never alone no matter what"}</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-sage-600 mt-1">•</span>
                <span>Receive my wholehearted support - happy dances included!</span>
              </li>
            </ul>
          </div>

          {/* We Center the Body */}
          <div>
            <h3 className="text-3xl md:text-4xl font-serif font-light text-sage-800 mb-6 text-center">We Center the Body</h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              An important part of my work includes helping you listen and learn what's happening at your nervous system level as we are together.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mt-3">{"When you work with me, you will practice tracking the ebbs and flows of your nervous system learning to listen to and attune to the wisdom of your body. In session with me, there is silence interspersed with the talking so that shifts in the body are given space. I guide you in how to use this space so we can listen and understand what your body is saying."}</p>
          </div>

          {/* We Focus on Your Strengths */}
          <div>
            <h3 className="text-3xl md:text-4xl font-serif font-light text-sage-800 mb-6 text-center">We Focus on Your Strengths</h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              My approach helps you tap into your existing strengths and internal resources, including those you may not yet recognize.
            </p>
          </div>

          {/* We Create Sustainable Change */}
          <div>
            <h3 className="text-3xl md:text-4xl font-serif font-light text-sage-800 mb-6 text-center">We Create Sustainable Change</h3>
            <p className="text-lg text-gray-700 leading-relaxed mb-3">{"Real change doesn't happen all at once. It's built through small, steady shifts that your body can trust. I'll help you create supportive habits and routines using micro-habit formation and habit stacking, so growth feels natural, not overwhelming."}</p>
            <p className="text-lg text-gray-700 leading-relaxed mb-3">{"As we move through your process, I'll guide you through the obstacles that arise and help you keep making progress at a pace that feels right for your nervous system. You decide when to pause, slow down, or rest. When anxiety shows up, we listen to it, allow the anxiety to inform us and use tools to regulate, recalibrate, and return to safety before moving forward."}</p>
            <p className="text-lg text-gray-700 leading-relaxed">Each step honors your capacity, helping change take root in a way that's sustainable and compassionate.</p>
          </div>

          {/* Full Width Section with Bolded Text */}
          <div className="mt-12 p-8 bg-gradient-to-br from-warm-50 to-cream-100 rounded-2xl border-2 border-warm-200">
            <p className="text-lg text-gray-700 leading-relaxed text-center font-medium">
              You'll have my full support and steady encouragement as you learn yourself and make shifts that lead to real, sustainable change.<br />
              I will celebrate you and your progress every step of the way, sometimes with a happy dance!
            </p>
            <p className="text-2xl md:text-3xl text-warm-700 leading-relaxed text-center mt-6 font-light italic">
              With me, you practice learning to love all of you.<br />
              You practice getting behind and supporting all of you.
            </p>
          </div>
        </div>
      </section>

      {/* Therapeutic Modalities Section */}
      <section className="py-16 px-4 md:px-8 bg-cream-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-[2.4rem] leading-none leading-8 [font-family:Cormorant_Garamond,serif] text-sage-800 mb-8 text-center">
            Therapeutic Modalities
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-16 max-w-4xl mx-auto text-center">I offer more than just talk therapy. I use evidence-based, research-backed and neuroscience-informed  approaches to address root causes of trauma underlying pleasing tendencies.</p>

          {/* 2x2 Grid for Main Modalities with Expandable Details */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Polyvagal Theory */}
            <div className="bg-white rounded-xl p-8 shadow-sm border border-sage-100">
              <h3 className="text-[2rem] leading-8 [font-family:Cormorant_Garamond,serif] text-sage-800 mb-4">
                Polyvagal Theory
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">{"Polyvagal Theory helps us understand how the nervous system responds to safety and threat. Many people-pleasers exist in a chronic \"fawn\" response, where saying \"no\" feels dangerous. This isn't a character flaw, it's a nervous system state."}</p>
              <details className="group">
                <summary className="flex items-center justify-between cursor-pointer list-none text-sage-700 hover:text-sage-800 transition-colors">
                  <span className="text-base">Through gentle practices like vagus nerve stimulation...</span>
                  <span className="ml-2 transform transition-transform duration-200 group-open:rotate-180">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </summary>
                <div className="mt-4 bg-sage-50/30 rounded-lg p-4 border-l-3 border-sage-200">
                  <p className="text-base text-gray-500 leading-relaxed">{"Through gentle practices like vagus nerve stimulation, we build your nervous system's capacity to feel safe enough to set boundaries, without defaulting to people-pleasing or fawning. We work on both self-regulation and co-regulation, creating safety within your own body and in relationship with others."}</p>
                </div>
              </details>
            </div>

            {/* Internal Family Systems */}
            <div className="bg-white rounded-xl p-8 shadow-sm border border-sage-100">
              <h3 className="text-[2rem] leading-8 [font-family:Cormorant_Garamond,serif] text-sage-800 mb-4">
                Internal Family Systems (IFS)
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">{"IFS recognizes that we all have different \"parts\", the people-pleaser, the inner critic, the protector. These parts often work against each other, creating internal conflict and exhaustion. When properly supported, each part can shift from its extreme role into a healthier state."}</p>
              <details className="group">
                <summary className="flex items-center justify-between cursor-pointer list-none text-sage-700 hover:text-sage-800 transition-colors">
                  <span className="text-base">We work together to help your parts unburden...</span>
                  <span className="ml-2 transform transition-transform duration-200 group-open:rotate-180">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </summary>
                <div className="mt-4 bg-sage-50/30 rounded-lg p-4 border-l-3 border-sage-200">
                  <p className="text-base text-gray-500 leading-relaxed">
                    We work together to help your parts unburden—releasing the heavy roles they've carried. When your inner people-pleaser relaxes, your authentic self can emerge. When your inner critic softens, you can access your natural wisdom and compassion.
                  </p>
                </div>
              </details>
            </div>

            {/* Attachment-Based Therapy */}
            <div className="bg-white rounded-xl p-8 shadow-sm border border-sage-100">
              <h3 className="text-[2rem] leading-8 [font-family:Cormorant_Garamond,serif] text-sage-800 mb-4">
                Attachment-Based Therapy
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">{"Our early relationships shape how we connect with others and ourselves. Many people-pleasers developed these patterns as children, learning that their needs were less important than keeping others happy. This isn't your fault, it was an adaptive response to your environment."}</p>
              <details className="group">
                <summary className="flex items-center justify-between cursor-pointer list-none text-sage-700 hover:text-sage-800 transition-colors">
                  <span className="text-base">We explore these attachment patterns with compassion...</span>
                  <span className="ml-2 transform transition-transform duration-200 group-open:rotate-180">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </summary>
                <div className="mt-4 bg-sage-50/30 rounded-lg p-4 border-l-3 border-sage-200">
                  <p className="text-base text-gray-500 leading-relaxed">{"We explore these attachment patterns with compassion, understanding how they helped you survive. Together, we create new, secure ways of relating first with yourself, then with others. You learn that your needs matter and that healthy relationships can hold both your needs and theirs."}</p>
                </div>
              </details>
            </div>

            {/* Somatic Approaches */}
            <div className="bg-white rounded-xl p-8 shadow-sm border border-sage-100">
              <h3 className="text-[2rem] leading-8 [font-family:Cormorant_Garamond,serif] text-sage-800 mb-4">Somatic Therapy</h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">{"Your body holds the story of your experiences, tension in your shoulders from saying \"yes\" when you wanted to say \"no,\" tightness in your chest from unexpressed feelings. Traditional talk therapy can only go so far; the body needs its own healing process."}</p>
              <details className="group">
                <summary className="flex items-center justify-between cursor-pointer list-none text-sage-700 hover:text-sage-800 transition-colors">
                  <span className="text-base">{"Through body-centered practices: breath work, gentle movement..."}</span>
                  <span className="ml-2 transform transition-transform duration-200 group-open:rotate-180">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </summary>
                <div className="mt-4 bg-sage-50/30 rounded-lg p-4 border-l-3 border-sage-200">
                  <p className="text-base text-gray-500 leading-relaxed">{"Through body-centered practices: breath work, gentle movement, somatic tracking and others, we help your body release stored tension and trauma. As your body learns to feel safe, your capacity for boundaries and authentic expression naturally expands."}</p>
                </div>
              </details>
            </div>
          </div>

          {/* Additional Training */}
          <div className="space-y-12">
            <div className="bg-white rounded-xl p-8 shadow-sm border border-sage-100">
              <h3 className="text-[2rem] leading-8 [font-family:Cormorant_Garamond,serif] text-sage-800 mb-6 text-center">Additional Modalities</h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-6 text-center">
                In addition to my primary approaches, I draw upon:
              </p>
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 text-center">
                <p className="text-[1.10rem] leading-6 text-gray-500">Cognitive Behavioral Therapy (CBT)</p>
                <p className="text-[1.10rem] leading-6 text-gray-500">Dialectical Behavior Therapy (DBT)</p>
                <p className="text-[1.1rem] leading-6 text-gray-500">Mindfulness-Based<br />Stress Reduction</p>
                <p className="text-[1.1rem] leading-6 text-gray-500">Object Relations Psychodynamics</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 md:px-8 bg-gradient-to-br from-sage-50 via-warm-50 to-cream-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-light text-sage-800 mb-6">
            Ready to Begin?
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            Let's explore how we can work together to help you reconnect with yourself and find your authentic voice.
          </p>
          <a className="inline-block bg-sage-600 text-white px-8 py-4 rounded-lg font-medium hover:bg-sage-700 transition-colors duration-300 shadow-md hover:shadow-lg" href="https://calendly.com/yphilipos/30min">
            Schedule a Consultation
          </a>
        </div>
      </section>

      <Footer />
    </div>;
};
export default MyApproachPage;